<template>
  <div>
    <div style="display: flex;align-items: center">
      <span style="color: red">
        <Icon type="ios-alert-outline" style="color: red"/>当前剩余查询次数{{ countMap.leaveCount }}次，查询时长{{ countMap.month }}个月</span>
      <div style="margin-left: auto;">
        <Button type="primary" style="border-radius: 5px" @click="setTime">查询时长</Button>
        <Button type="primary" style="border-radius: 5px;margin-left: 10px" @click="openAdd">新增</Button>
        <Button style="border-radius: 5px;margin-left: 10px" @click="queryUsesShipTrackRecordOrder">刷新</Button>
      </div>
    </div>
    <vxe-table
        style="margin-top: 10px"
        class="table-style"
        stripe
        align="center"
        highlight-hover-row
        border="inner"
        :loading="loading"
        :data="guijiData"
        height="400"
    >
      <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
      <vxe-table-column field="count" title="购买次数" show-overflow></vxe-table-column>
      <vxe-table-column field="leaveCount" title="剩余次数" show-overflow></vxe-table-column>
      <vxe-table-column field="endTime" title="截止有效期" min-width="150" show-overflow>
        <template slot-scope="{ row }">
          <span>{{ row.endTime | timeFormat }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="createTime" title="创建时间" min-width="150" show-overflow>
        <template slot-scope="{ row }">
          <span>{{ row.createTime | timeFormat }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="usedType" title="渠道" show-overflow>
        <template slot-scope="{ row }">
          {{ row.usedType | usedType }}
        </template>
      </vxe-table-column>
      <vxe-table-column field="action" title="操作" width="60">
        <template slot-scope="{ row }">
          <span v-if="row.usedType === 2"><a @click="commitDelete(row)">删除</a></span>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
        background
        size="small"
        :current-page.sync="page"
        :page-size.sync="rows"
        :total="total"
        @page-change="change"
    ></vxe-pager>
    <div class="title">
      <div class="block"></div>
      <div style="display: flex;align-items: center">
        <span>轨迹查询历史记录</span>
        <Button icon="ios-time-outline" style="color: #1A8CFE;margin-left: 10px;border-radius: 5px"
                @click="openHistory">历史记录
        </Button>
      </div>
    </div>
    <vxe-modal v-model="historyModal" width="1000" height="630" position="center" title="历史记录" destroy-on-close transfer>
      <history ref="history" :userId="userId" @close="historyModal = false"></history>
    </vxe-modal>
    <vxe-modal v-model="timeModal" width="500" height="200" position="center" title="查询时长" destroy-on-close transfer>
      <set-time ref="setTime" :userId="userId" @afterSave="afterSave"></set-time>
    </vxe-modal>
    <vxe-modal v-model="createModal" width="500" height="300" position="center" title="新增" destroy-on-close transfer>
      <add-guiji ref="createModal" :userId="userId" @afterSave="afterSave"></add-guiji>
    </vxe-modal>
  </div>
</template>
<script>
import $api from "@/apiProvider";
import GuijiHistory from "@/components/userManage/GuijiHistory";
import {hideLoading, isNotEmpty, showLoading} from "@/utils/util";
import SetTime from "@/components/userManage/SetTime";
import AddGuiji from "@/components/userManage/AddGuiji";

export default {
  props: ['userId'],
  components: {History: GuijiHistory, SetTime, AddGuiji},
  data() {
    return {
      loading: false,
      guijiData: [],
      page: 1,
      rows: 10,
      total: 100,
      historyModal: false,
      timeModal: false,
      createModal: false,
      countMap: {
        leaveCount: 0,
        month: 0
      }
    }
  },
  filters: {
    usedType(val) {
      if (val === 1) {
        return "线上购买";
      } else if (val === 2) {
        return "平台新增";
      }
    },
  },
  watch: {
    userId(val) {
      if (val) {
        this.queryUsesShipTrackRecordOrder();
      }
    },
  },
  methods: {
    setTime() {
      this.timeModal = true;
      this.$nextTick(() => {
        this.$refs.setTime.init(this.countMap.month);
      })
    },
    openAdd() {
      this.createModal = true;
    },
    afterSave() {
      this.timeModal = false;
      this.createModal = false;
      this.queryUsesShipTrackRecordOrder();
    },
    openHistory() {
      this.historyModal = true;
    },
    change(val) {
      this.page = val.currentPage;
      this.rows = val.pageSize;
      this.queryUsesShipTrackRecordOrder();
    },
    async queryUsesShipTrackRecordOrder() {
      this.loading = true;
      let res = await $api.seachart.request("queryUsesShipTrackRecordOrder", {
        userId: this.userId,
        page: this.page,
        rows: this.rows,
        recordType: 1,
      });
      this.loading = false;
      if (res.code === 1) {
        this.total = res.data.total;
        this.guijiData = res.data.list;
        this.countMap = res.data.countMap;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    commitDelete(row) {
      this.$XModal.confirm("您确定要删除吗？").then((type) => {
        if (type === "confirm") {
          this.delete(row);
        }
      });
    },
    async delete(row) {
      showLoading();
      let res = await $api.seachart.request("removeUsesShipTrackRecordOrder", {
        userId: this.userId,
        id: row.id,
      });
      hideLoading();
      if (res.code === 1) {
        this.$Message.success("删除成功");
        this.queryUsesShipTrackRecordOrder();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    }
  }
}
</script>
<style scoped>
.title {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 400;
  color: #333333;
}

.block {
  margin-right: 5px;
  width: 3px;
  height: 14px;
  background: #438DF3;
}

.flex {
  display: flex;
  align-items: center;
}
</style>